import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class ActiveTwilioNumbersRequest extends DBObject {
  private static readonly _ASCENDING: number = 0;
  private static readonly _OFFSET: number = 1;
  private static readonly _PAGESIZE: number = 2;
  public id: number = 0;
  public otherMaster: DBObject;
  private _pageSize: number = 0;
  private _offset: number = 0;
  private _ascending: boolean = false;
  public constructor(
    d3eParams?: Partial<{
      ascending: boolean;
      offset: number;
      pageSize: number;
    }>
  ) {
    super();

    this.setAscending(d3eParams?.ascending ?? false);

    this.setOffset(d3eParams?.offset ?? 0);

    this.setPageSize(d3eParams?.pageSize ?? 0);
  }
  public get d3eType(): string {
    return "ActiveTwilioNumbersRequest";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get isTransientModel(): boolean {
    return;
  }
  public get pageSize(): number {
    return this._pageSize;
  }
  public setPageSize(val: number): void {
    let isValChanged: boolean = this._pageSize !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(ActiveTwilioNumbersRequest._PAGESIZE, this._pageSize);

    this._pageSize = val;

    this.fire("pageSize", this);
  }
  public get offset(): number {
    return this._offset;
  }
  public setOffset(val: number): void {
    let isValChanged: boolean = this._offset !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(ActiveTwilioNumbersRequest._OFFSET, this._offset);

    this._offset = val;

    this.fire("offset", this);
  }
  public get ascending(): boolean {
    return this._ascending;
  }
  public setAscending(val: boolean): void {
    let isValChanged: boolean = this._ascending !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(
      ActiveTwilioNumbersRequest._ASCENDING,
      this._ascending
    );

    this._ascending = val;

    this.fire("ascending", this);
  }
  public get(field: number): any {
    switch (field) {
      case ActiveTwilioNumbersRequest._PAGESIZE: {
        return this._pageSize;
      }

      case ActiveTwilioNumbersRequest._OFFSET: {
        return this._offset;
      }

      case ActiveTwilioNumbersRequest._ASCENDING: {
        return this._ascending;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): ActiveTwilioNumbersRequest {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: ActiveTwilioNumbersRequest = dbObj as ActiveTwilioNumbersRequest;

    obj.id = this.id;

    obj.setPageSize(this._pageSize);

    obj.setOffset(this._offset);

    obj.setAscending(this._ascending);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case ActiveTwilioNumbersRequest._PAGESIZE: {
        this.setPageSize(value as number);
        break;
      }

      case ActiveTwilioNumbersRequest._OFFSET: {
        this.setOffset(value as number);
        break;
      }

      case ActiveTwilioNumbersRequest._ASCENDING: {
        this.setAscending(value as boolean);
        break;
      }
    }
  }
}
